import AgreeToUseParagraph from './AgreeToUseParagraph'

export default AgreeToUseParagraph
